import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SafeUrl} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CanvasService {
  private canvasSignatureImageSource = new BehaviorSubject(null);
  canvasSignatureImage = this.canvasSignatureImageSource.asObservable();

  private canvasSignatureImageUrlSource = new BehaviorSubject('');
  canvasSignatureImageUrl = this.canvasSignatureImageUrlSource.asObservable();

  private isSelectSignDrawSource = new BehaviorSubject(false);
  isSelectSignDraw = this.isSelectSignDrawSource.asObservable();

  private canvasImageSource = new BehaviorSubject(null);
  canvasImage = this.canvasImageSource.asObservable();

  private canvasImageUrlSource = new BehaviorSubject(null);
  canvasImageUrl = this.canvasImageUrlSource.asObservable();

  private isDisableBtnDeleteCanvasSource = new BehaviorSubject(true);
  isDisableBtnDeleteCanvas = this.isDisableBtnDeleteCanvasSource.asObservable();

  // trạng thái "đã bấm Áp dụng" sau khi vẽ chữ ký - dùng để disable nút Ký
  private isApplyDrawSignatureSource = new BehaviorSubject(false);
  isApplyDrawSignature = this.isApplyDrawSignatureSource.asObservable();
  isApplyDrawSignatureValue = false;

  private isVisibleModalDrawSignatureSource = new BehaviorSubject(false);
  isVisibleModalDrawSignature = this.isVisibleModalDrawSignatureSource.asObservable();

  constructor() {
  }

  setCanvasSignatureImage(canvasImage: File) {
    this.canvasSignatureImageSource.next(canvasImage);
  }

  setCanvasSignatureImageUrl(canvasImageUrl: string) {
    this.canvasSignatureImageUrlSource.next(canvasImageUrl);
  }

  setIsSelectSignDraw(state: boolean) {
    this.isSelectSignDrawSource.next(state);
  }

  setCanvasImage(canvasImage: File) {
    this.canvasImageSource.next(canvasImage);
  }

  setCanvasImageUrl(canvasImageUrl: string | SafeUrl) {
    this.canvasImageUrlSource.next(canvasImageUrl);
  }

  setIsDisableBtnDeleteCanvas(state: boolean) {
    this.isDisableBtnDeleteCanvasSource.next(state);
  }

  setIsApplyDrawSignature(state: boolean) {
    this.isApplyDrawSignatureValue = state;
    this.isApplyDrawSignatureSource.next(state);
  }

  setIsVisibleModalDrawSignature(val: boolean) {
    this.isVisibleModalDrawSignatureSource.next(val);
  }
}
